<!--  -->
<template>
  <div class="myplan-management">
      <div class="myplan-management-tabs">
          <div class="myplan-management-tabs-top">
            <div class="myplan-management-tabs-bd"   @click="handleTabStatus">
              <div class="toggle-title">{{isOverviewStatus?'申请规划全览':'申请时间表'}}</div>
              <div class="toggle-title-btn"><Icon type="md-repeat" class='icon-repeat' /><span>切换</span></div>
            </div>
            <div class="historical-records" @click="$router.push({name:'myplan-history'})">
              <span class="icon-box"><Icon type="ios-mail" class="icon-mail" /><i class="dot"></i></span><span class="historical-records-name">查看跟进历史记录</span>
            </div>
          </div>
          <div>
            <div class="myplan-management-tabs-hd" v-show="isOverviewStatus">
              <myplan-overview-item  :isOverviewStatus='true' ref="overviewItemMentee"></myplan-overview-item>
            </div>
            <div class="myplan-management-tabs-hd" v-show="!isOverviewStatus">
              <myplan-overview-item-times  :isOverviewStatus='false' ref="overviewItemTimesMentee"></myplan-overview-item-times>
            </div>
          </div>
      </div>
  </div>
</template>
<script>

import MyplanOverviewItem from './myplan-overview-item'
import MyplanOverviewItemTimes from './myplan-overview-item-times'
export default {
  name: 'myplan-overview-tabs',
  components: {
    MyplanOverviewItem,
    MyplanOverviewItemTimes
  },
  data () {
    return {
      // 查看历史记录
      isHistorical: false,
      // 全览时间状态
      isOverviewStatus: true
    }
  },
  computed: {},
  mounted () {},
  methods: {
    // 切换Tabs
    handleTabStatus () {
      this.isOverviewStatus = !this.isOverviewStatus
      if (this.isOverviewStatus) {
        this.$refs.overviewItemMentee.getCategoryList()
      } else {
        this.$refs.overviewItemTimesMentee.planQueryInfoPhasesList()
      }
    }
  }
}
</script>

<style lang='less' scoped>
// tabs
.myplan-management-tabs{
  margin-top:56px;
  //查看历史记录
  .historical-records{
    cursor:pointer;
    &-name {
      font-weight: 600;
      color: #6589DD;
      font-size:18px;
      text-decoration: underline;
    }
    .icon-mail{
      font-size:24px;
      color:#666666;
      padding-right:14px;
    }
    .icon-box{
      position: relative;
    }
    .dot {
      position: absolute;
      right:10px;
      top:-4px;
      width: 14px;
      height: 14px;
      background: #FF0000;
      border: 2px solid #FFFFFF;
      border-radius: 50%;
    }
  }
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom:56px;
  }
  &-bd{
    display: flex;
    align-items: center;
    .toggle-title{
        padding:0 60px;
        font-weight: 600;
        font-size:18px;
        height:60px;
        line-height:60px;
        color:#6589DD;
        background-color:#EAEFFB;
    }
    .toggle-title-btn{
      height:60px;
      line-height:60px;
      padding:0 20px;
      font-size:14px;
      color: #6589DD;
      cursor:pointer;
      background: #DDE6FA;
      border-radius: 0px 2px 2px 0px;

    }
  }
  .icon-repeat {
    padding-right:10px;
    font-weight: bold;
  }
}
</style>
